import React, { FC, useState } from 'react';
import { useParams } from 'react-router';

import { EvErrorCard, EvFlexRow, useSkipLinks } from '@evinced-private/ui-common';

import { MfaComponentDetailsBlock } from 'src/apps/mfa/components/MfaComponentDetailsBlock';
import { useMfaIssueQuery } from 'src/apps/mfa/hooks/useMfaIssueQuery';
import { useMfaSessionScansQuery } from 'src/apps/mfa/hooks/useMfaSessionScansQuery';
import { useSetMfaBreadcrumbs } from 'src/apps/mfa/hooks/useSetMfaBreadcrumbs';
import { formatDate } from 'src/common/helpers/DateFormatHelper';
import { useWhiteBackground } from 'src/common/hooks/useWhiteBackground';
import { DASHBOARD_ERROR_MSG } from 'src/common/pages/dashboards-container/errorMessages';

import './MfaSingleIssuePage.scss';

export const MfaSingleIssuePage: FC = () => {
	const { sessionId, issueId } = useParams<{ sessionId: string; issueId: string }>();
	const [error, setError] = useState(null);

	useSkipLinks(true);
	useWhiteBackground();
	const issueQuery = useMfaIssueQuery(issueId, sessionId);
	const scansQuery = useMfaSessionScansQuery({ sessionId });
	const scanCreatedAt = formatDate(scansQuery.data?.get(issueQuery.data?.scanId)) ?? '';
	useSetMfaBreadcrumbs(sessionId, issueQuery?.data?.sessionName ?? '');

	return (
		<div className="mfa-issue-details-page">
			{error ? (
				<EvFlexRow justify="CENTER">
					<EvErrorCard title="Error" contactUsMessage={DASHBOARD_ERROR_MSG} />
				</EvFlexRow>
			) : (
				<MfaComponentDetailsBlock
					runId={sessionId}
					issueId={issueId}
					scanName={issueQuery.data?.scanName}
					scanCreatedAt={scanCreatedAt}
					issueNumber={issueQuery.data?.shortNodeId}
					isFullPageMode
					setError={setError}
				/>
			)}
		</div>
	);
};
